import { Box, Text } from '@factorialco/deprecated-design-system'
import { PayrollConceptFragment } from 'generated/resources/graphql'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'

import CompareText from 'modules/payroll_bundle/components/CompareText'
import { ResultConcepts } from 'modules/payroll_bundle/lib/constants'
import { formatAmount } from 'modules/payroll_bundle/lib/formatNumber'
import {
  ResultRowData,
  getResultConceptItem,
  getResultRowDataDiffAmountInCents,
} from 'modules/payroll_bundle/lib/resultsTableData'

interface Props {
  resultRowData: ResultRowData
  policyPeriodIds: { current: number; previous: number }
  concept: PayrollConceptFragment
  currency: string
}

const ResultConceptListItem = ({ resultRowData, policyPeriodIds, concept, currency }: Props) => {
  const currentAmountInCents =
    getResultConceptItem(resultRowData, concept.id, policyPeriodIds.current)?.amount ?? null
  const diffAmountInCents = getResultRowDataDiffAmountInCents(
    resultRowData,
    concept.id,
    policyPeriodIds.current,
    policyPeriodIds.previous
  )
  const isRegularPayroll = resultRowData.paymentType === ResultConcepts.regular_payroll

  return (
    <Box
      key={concept.name}
      height="s64"
      padding="s16"
      border={{
        bottom: {
          width: 's1',
          color: 'grey400',
          style: 'solid',
        },
      }}
      justifyContent="center"
    >
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="flexStart" width="full">
        <Box gap="s4" flexDirection="row" alignItems="center">
          <Text.Normal color="grey800" size="200">
            {concept.label}
          </Text.Normal>
          {isRegularPayroll && diffAmountInCents === null && currentAmountInCents !== null && (
            <Box flexDirection="row" alignItems="center" component="span" width="s1" inline>
              <InformationTooltip
                information={i18n.t(
                  'payroll_bundle.results_payments.results.previous_value_not_informed'
                )}
                icon="question"
              />
            </Box>
          )}
        </Box>

        <Box alignItems="flexEnd">
          <Text.Normal weight="semibold" color="grey800">
            {currentAmountInCents !== null ? formatAmount(currentAmountInCents, currency) : '-'}
          </Text.Normal>

          {isRegularPayroll && diffAmountInCents !== null && (
            <CompareText amount={Math.round(diffAmountInCents)} currency={currency} />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default ResultConceptListItem
